import loadable from '@loadable/component';

// 懒加载组件
const EquDeliveryQuery = loadable(() => import('./equDelivery/EquDeliveryQuery'));
const EquDeliveryModify = loadable(() => import('./equDelivery/equDeliveryModify/EquDeliveryModify'));

export const subRoutes = [
  {
    // 器械发货单查询
    path: '/EquDeliveryQuery',
    component: EquDeliveryQuery
  },
  {
    // 器械发货单修改
    path: '/EquDeliveryModify',
    component: EquDeliveryModify
  }
];
